import * as React from "react";
import { useState } from "react";
import { DataTable, PaginatedList, Spinner, NoSearchResult } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import SyncedTeamsOverviewItem from "./SyncedTeamsOverviewItem";
import SyncedTeamsFilter from "./SyncedTeamsFilter";
import LicenseCheck from "../../license/LicenseCheck";
import { useSyncedTeamsPaginated } from "../hooks/useTeamSync";
const DEFAULT_PAGINATION = {
  page: 1,
  perPage: 10,
  query: ""
};
const TABLE_HEADERS = ["Name", "Users", "Roles"];
const _headerCellFormatter = (header) => {
  switch (header.toLocaleLowerCase()) {
    case "actions":
      return /* @__PURE__ */ React.createElement("th", { className: "actions text-right" }, header);
    default:
      return /* @__PURE__ */ React.createElement("th", null, header);
  }
};
const SyncedTeamsSection = ({ authenticationBackend }) => {
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const { page } = pagination;
  const { data: paginatedTeams, isFetching } = useSyncedTeamsPaginated(authenticationBackend.id, pagination);
  if (!paginatedTeams) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const searchFilter = /* @__PURE__ */ React.createElement(
    SyncedTeamsFilter,
    {
      onSearch: (newQuery) => setPagination({ ...pagination, query: newQuery, page: DEFAULT_PAGINATION.page })
    }
  );
  return /* @__PURE__ */ React.createElement(SectionComponent, { title: "Synchronized Teams", showLoading: isFetching }, /* @__PURE__ */ React.createElement(LicenseCheck, null, /* @__PURE__ */ React.createElement("p", { className: "description" }, "Found ", paginatedTeams.pagination.total, " synchronized teams."), /* @__PURE__ */ React.createElement(
    PaginatedList,
    {
      activePage: page,
      totalItems: paginatedTeams.pagination.total,
      onChange: (newPage, newPerPage) => setPagination({
        ...pagination,
        page: newPage,
        perPage: newPerPage
      }),
      useQueryParameter: false
    },
    /* @__PURE__ */ React.createElement(
      DataTable,
      {
        customFilter: searchFilter,
        dataRowFormatter: (team) => /* @__PURE__ */ React.createElement(
          SyncedTeamsOverviewItem,
          {
            team,
            rolesContext: paginatedTeams.context.roles,
            usersContext: paginatedTeams.context.users
          }
        ),
        filterKeys: [],
        filterLabel: "Filter Teams",
        headerCellFormatter: _headerCellFormatter,
        headers: TABLE_HEADERS,
        id: "synced-teams-overview",
        noDataText: /* @__PURE__ */ React.createElement(NoSearchResult, null, "No synchronized teams have been found."),
        rowClassName: "no-bm",
        rows: paginatedTeams.list.toJS(),
        sortByKey: "name"
      }
    )
  )));
};
export default SyncedTeamsSection;
